import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { TaskSubTasksResult } from './TaskSubTaskResult'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'

@InputType()
export class DeleteTaskSubTasksArgs extends ActionArgs {
  @Field(() => ID)
  taskId: string

  @Field(() => [String])
  subTaskIds: string[]
}

@ObjectType()
export class DeleteTaskSubTasksResult extends TaskSubTasksResult {}

export interface IDeleteTaskSubTasks extends IAction<DeleteTaskSubTasksResult, DeleteTaskSubTasksArgs> {}
